<template>
  <div class="content-430">
    <div class="class-form-head">课程详情</div>
    <div class="class-form-content">
      <Form
        ref="courseDetailInfo"
        :model="courseDetailInfo"
        label-position="right"
        :label-width="120"
        :rules="courseDetailInfoRule"
      >
        <FormItem label="课程封面" prop="courseCoverShow">
          <div class="flex upload">
            <div
              v-if="courseDetailInfo.courseCoverShow"
              class="cover-img-block"
            >
              <div class="rightBox"></div>
              <img
                v-if="courseDetailInfo.courseCoverShow.fileId"
                :src="
                  downloadUrl +
                    '?fileId=' +
                    courseDetailInfo.courseCoverShow.fileId
                "
                alt=""
                class="img-set"
              >
              <img
                v-else
                class="img-set"
                :src="courseDetailInfo.courseCoverShow.imgShow"
                alt=""
              >
              <Icon
                type="ios-close"
                size="30"
                class="delBtn"
                @click="handleDelCover"
              ></Icon>
            </div>
          </div>
          <UploadBtn
            text="上传图片"
            class="ml-2"
            :upload-type="0"
            :accept="`image/*`"
            @on-success="handleUploadImg"
          ></UploadBtn>
        </FormItem>
        <FormItem label="课程介绍" class="editor-sytle" prop="courseDescribe">
          <Editor ref="editorRef"></Editor>
          <span class="preLook" @click="showPreModalShow">预览</span>
          <!-- <div id="wangeditor" ref="wangeditor"></div>
          <span class="preLook" @click="showPreModalShow">预览</span> -->
        </FormItem>
        <FormItem label="成果展示">
          <div
            v-show="courseDetailInfo.courseAchievementShow.length"
            class="imgWrap"
          >
            <div
              v-for="(item, index) in courseDetailInfo.courseAchievementShow"
              :key="index"
              class="imgBox"
            >
              <div class="rightBox"></div>
              <img
                v-if="item.fileId"
                :src="downloadUrl + '?fileId=' + item.fileId"
                alt=""
                class="img-set"
              >
              <img v-else :src="item.imgShow" alt="" class="img-set">
              <Icon
                type="ios-close"
                size="30"
                class="delBtn"
                @click="handleDelFile(index)"
              ></Icon>
            </div>
          </div>
          <UploadBtn
            text="上传图片"
            class="upload mb-1"
            :multiple="true"
            :upload-type="1"
            :accept="`image/*`"
            @on-success="handleUploadImg1"
          ></UploadBtn>
        </FormItem>
        <FormItem label="课外单价" prop="outCoursePriceShow">
          <Input
            v-model="courseDetailInfo.outCoursePriceShow"
            placeholder="请填写"
            class="w-40"
            @on-blur="
              getTrueFee('outCoursePrice', courseDetailInfo.outCoursePriceShow)
            "
          ></Input>
          <span class="ml-2">元/节</span>
        </FormItem>
        <FormItem label="课内单价" prop="coursePriceShow">
          <Input
            v-model="courseDetailInfo.coursePriceShow"
            placeholder="请填写"
            class="w-40"
            @on-blur="
              getTrueFee('coursePrice', courseDetailInfo.coursePriceShow)
            "
          ></Input>
          <span class="ml-2">元/节</span>
        </FormItem>
      </Form>
    </div>
    <PreLook
      :visible="preModalShow"
      :data="courseDetailInfo.courseDescribe"
      @close="preModalShow = !preModalShow"
    ></PreLook>
  </div>
</template>
<script>
// import E from 'wangeditor';
import Editor from '@c/Base/Editor';
import UploadBtn from '@c/UploadBtn';
import { readFileOfImage, editorGetText, editorIsNull } from '@/utils/utils';
import { compressPic, dataURLtoFile } from '@/utils/imageHelper';
import PreLook from './PreLook.vue';
export default {
  components: {
    UploadBtn,
    PreLook,
    Editor
  },
  inject: ['EditCurriculumInstance'],
  props: {
    value: {
      type: Object,
      default: () => {
        return {
          courseCoverShow: null, // 课程封面展示
          courseCover: '', // 课程封面
          courseDescribe: '', // 课程介绍
          courseAchievementShow: [], // 成果展示
          courseAchievement: '', // 成果展示
          coursePriceShow: '', // 页面展示的校内单价
          coursePrice: '', // 校内单价(页面展示的校内单价*100)
          outCoursePriceShow: '', // 页面展示的校外单价
          outCoursePrice: '' // 校外单价(页面展示的校外单价*100)
        };
      }
    }, // v-model的值
    theUserIdentity: {
      type: String,
      default: ''
    },
    courseId: {
      type: String,
      default: ''
    },
    downloadUrl: {
      type: String,
      default: ''
    },
    validatePass: {
      type: Boolean,
      default: false
    } // 校验是否通过
  },
  data() {
    // 课程价格规则
    const validateCoursePrice = (rule, value, callback) => {
      console.log(value, '-------', rule);
      if (value === '' || value === null) {
        callback();
        return;
      }
      const number = Number(value);
      if (isNaN(number)) {
        callback(new Error('请输入正确的数字'));
        return;
      }
      if (number < 0) {
        callback(new Error('请输入大于或等于0的金额'));
        return;
      }
      let length = 0;
      const arr = value.split('.');
      if (arr.length === 2) {
        length = arr[1].length;
      }
      if (length > 2) {
        callback(new Error('请输入最多两位小数的金额'));
        return;
      } else {
        callback();
        return;
      }
    };
    return {
      courseDetailInfoRule: {
        courseDescribe: [
          { required: true, message: '请填写课程介绍', trigger: 'change' }
        ],
        outCoursePriceShow: [{ validator: validateCoursePrice, trigger: 'blur' }],
        coursePriceShow: [{ validator: validateCoursePrice, trigger: 'blur' }]
      }, // 基础信息表单
      editor: null,
      preModalShow: false
    };
  },
  computed: {
    courseDetailInfo: {
      get() {
        return this.value;
      },
      set(newVal) {
        this.$emit('input', newVal);
      }
    }

  },
  watch: {
    courseDetailInfo: {
      handler(newVal, oldVal) {
        this.EditCurriculumInstance.findRuleRequireNew(this, 'courseDetailInfo', '课程详情');
      },
      deep: true
    }
  },

  mounted() {
    // this.initE();
    this.EditCurriculumInstance.findRuleRequireNew(this, 'courseDetailInfo', '课程详情');
  },
  methods: {
    // 校验表单
    checkForm() {
      return new Promise((resolve, reject) => {
        this.courseDetailInfo.courseDescribe = this.$refs.editorRef.getEditorContext();
        this.$nextTick(() => {
          this.$refs.courseDetailInfo.validate((valid) => {
            console.log(valid, '验证现在是否成功了----3453');
            if (valid) {
              this.$emit('update:validatePass', true);
            } else {
              this.EditCurriculumInstance.findRuleRequireNew(this, 'courseDetailInfo', '课程详情', true);
              this.$emit('update:validatePass', false);
            }
            resolve();
          });
        });
      });
    },
    initE() {
      this.editor = new E('#wangeditor');
      // 这里各位小伙伴可以查询官网，根据自己的需求进行菜单栏调整
      this.editor.config.menus = [
        'head', // 标题
        'bold', // 粗体
        'fontSize', // 字号
        'fontName', // 字体
        'italic', // 斜体
        'foreColor', // 文字颜色
        'list', // 列表
        'justify' // 对齐方式
      ];
      this.editor.config.onblur = (html) => {
        this.courseDetailInfo.courseDescribe = editorIsNull(editorGetText(html)) ? '' : html;
        console.log(this.courseDetailInfo.courseDescribe, '============');
        this.$refs.courseDetailInfo.validateField('courseDescribe');
        this.EditCurriculumInstance.findRuleRequireNew(this, 'courseDetailInfo', '课程详情');
      };
      this.editor.create();
    },
    fillEditor(context) {
      this.$refs.editorRef.setEditorContext(context);
      // this.editor.txt.html(context.replace(/\n/g, '<br/>'));
    },
    // 上传文件
    async handleUploadImg(files) {
      const file = files[0];
      const fileSize = file.size;
      try {
        const result = await readFileOfImage(file);
        let yaImageStr = ''; // 压缩后的base64图片
        // 如果图片大小大于200k,先进行压缩
        if (Math.round(fileSize / 1024) > 200) {
          yaImageStr = await compressPic(result, {
            quality: 0.7
          });
        } else {
          yaImageStr = result;
        }
        const newFile = dataURLtoFile(yaImageStr, file.name);
        if ((newFile.size / 1024) > 5 * 1024) {
          return this.$Message.error('图片太大！请重新上传');
        }
        const obj = {
          fileId: '',
          file: newFile,
          imgShow: yaImageStr
        };
        this.$set(this.courseDetailInfo, 'courseCoverShow', obj);
        console.log(obj, this.courseDetailInfo, '上传文件----------');
      } catch (error) {
        this.$Message.warning('读取图片失败');
      }
    },
    showPreModalShow() {
      if (!this.preModalShow) {
        this.courseDetailInfo.courseDescribe = this.$refs.editorRef.getEditorContext();
      }
      this.preModalShow = !this.preModalShow;
    },
    // 删除成果展示图片
    handleDelFile(index) {
      this.courseDetailInfo.courseAchievementShow.splice(index, 1);
    },
    handleDelCover() {
      this.courseDetailInfo.courseCoverShow = null;
    },
    // 上传多张图片
    async handleUploadImg1(files) {
      var arr = Object.keys(files);
      if (this.courseDetailInfo.courseAchievementShow + arr.length > 6) {
        this.$Message.warning('最多上传6张成果展示图片！');
        return false;
      }
      for (const key in files) {
        const file = files[key];
        const fileSize = file.size;
        try {
          const result = await readFileOfImage(file);
          let yaImageStr = ''; // 压缩后的base64图片
          // 如果图片大小大于200k,先进行压缩
          if (Math.round(fileSize / 1024) > 200) {
            yaImageStr = await compressPic(result, {
              quality: 0.7
            });
          } else {
            yaImageStr = result;
          }
          const newFile = dataURLtoFile(yaImageStr, file.name);
          if ((newFile.size / 1024) > 5 * 1024) {
            return this.$Message.error('图片太大！请重新上传');
          }
          const obj = {
            fileId: '',
            file: newFile,
            imgShow: yaImageStr
          };
          this.courseDetailInfo.courseAchievementShow.push(obj);
        } catch (error) {
          // this.$Message.warning('读取图片失败');
        }
      }
    },
    getTrueFee(tag, value) {
      if (value) {
        this.courseDetailInfo[tag] = value * 100;
      } else {
        this.courseDetailInfo[tag] = '';
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.editor-sytle {
  /deep/.ivu-form-item-content {
    z-index: 1;
  }
}
.preLook {
  display: inline-block;
  margin-top: 20px;
  width: 60px;
  height: 36px;
  background: rgb(247, 248, 250);
  font-size: 14px;
  text-align: center;
  line-height: 36px;
}
.imgWrap {
  display: flex;
  max-width: 400px;
  flex-wrap: wrap;
  // justify-content: flex-start;
  align-items: flex-end;

  // margin-bottom: 20px;
  .imgBox {
    position: relative;
    margin: 5px 10px;

    // border: 1px solid #e5e5e5;
    .rightBox {
      width: 20px;
      height: 20px;
      background-color: rgba(0, 0, 0, 0.7);
      border-radius: 0 0 0 12px;
      position: absolute;
      top: 0;
      right: 0;
    }

    .delBtn {
      position: absolute;
      top: -5px;
      right: -5px;
      color: #fff;
      cursor: pointer;
    }
  }
}
.img-set {
  // width: 100px;
  height: 100px;
}
.ml-2 {
  margin-left: 8px;
}
.cover-img-block {
  position: relative;
  .rightBox {
    width: 20px;
    height: 20px;
    background-color: rgba(0, 0, 0, 0.7);
    border-radius: 0 0 0 12px;
    position: absolute;
    top: 0;
    right: 0;
  }
  .delBtn {
    position: absolute;
    top: -5px;
    right: -5px;
    color: #fff;
    cursor: pointer;
  }
}
</style>
